import { useCallback, useContext, useEffect, useRef, useState } from 'react';
import RightMenuDesign from '../../../../components/house/RightMenuDesign/RightMenuDesign';
import { DesignerPageContext } from '../../DesignerPage';
import { useDispatch, useSelector } from 'react-redux';
import ButtonIconGhostMedium from '../../../../components/common/ButtonIconGhost/ButtonIconGhostMedium';
import { Icon } from '../../../../components/icon/icon';
import RightSupplierMenu from '../RightSupplierMenu/RightSupplierMenu';
import { useTranslation } from 'react-i18next';
import { setCurrentSupplier } from '../../../../store/reducers/supplier.reducer';
import {
  fetchGroupMaterial,
  fetchMaterialsByGroup,
} from '../../../../store/actions/material.action';
import { openMessageError } from '../../../../components/common/Message/openMessageError';
import SelectionSupplier from '../SelectionSuplier/SelectionSuplier';
import { Collapse } from 'antd';
import { Empty } from 'antd';
import { getValueFromString } from '../../../../utils/data/getValue.utils';
import { Spin } from 'antd';
import CardMaterial from '../CardMaterial/CardMaterial';
import { fetchSuppliers } from '../../../../store/actions/supplier.action';

const RightTextileShoeLowerBench = ({ open, onClose, title }) => {
  const [openSupplier, setOpenSupplier] = useState(false);
  const timerRef = useRef();

  const {
    currentSupplier: { shoeLowerBench: supplierId },
  } = useSelector(state => state.supplier);

  useEffect(() => {
    if (!supplierId?.id && open) {
      timerRef.current = setTimeout(() => {
        setOpenSupplier(true);
      }, 1000);
    } else {
      clearTimeout(timerRef.current);
      timerRef.current = null;
    }
    return () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
        timerRef.current = null;
      }
    };
  }, [open, supplierId]);

  return (
    <>
      <RightMenuDesign
        open={open}
        classNames={{ root: 'top-84', content: 'flex flex-col !p-0 gap-0' }}
        header={
          <div className="flex self-stretch items-center justify-start gap-8">
            <ButtonIconGhostMedium
              icon={<Icon.ICArrowBack />}
              onClick={onClose}
            />
            <span className="text-title-large">{title}</span>
          </div>
        }
        content={
          open ? <RenderContent setOpenSupplier={setOpenSupplier} /> : null
        }
      />
      {open ? (
        <RightSupplierMenu
          open={openSupplier}
          onClose={() => setOpenSupplier(false)}
          otherType={'textile'}
          type={'shoeLowerBench'}
        />
      ) : (
        <></>
      )}
    </>
  );
};

export default RightTextileShoeLowerBench;

const RenderContent = ({ setOpenSupplier }) => {
  const { selectedModels, selectedModel, sceneManager } =
    useContext(DesignerPageContext);
  const { t } = useTranslation();

  const dispatch = useDispatch();
  const { listMaterials, groupMaterials } = useSelector(
    state => state.materialReducer
  );
  const {
    suppliers,
    currentSupplier: { shoeLowerBench: supplierId },
  } = useSelector(state => state.supplier);

  const [texture, setTexture] = useState();

  const [activeKeys, setActiveKeys] = useState([]);
  // const [currentMaterial, setCurrentMaterial] = useState();

  const traverseColorAndTexture = useCallback(
    selectedModel => {
      let supplierIds = { ...(supplierId ?? {}) };
      const modules = sceneManager?.cabinetManager?.currentCabinet?.modules;
      if (modules) {
        const moduleEntries = Array.from(modules.entries());
        const module = moduleEntries?.find(
          ([item, value]) => value.group.uuid === selectedModel.uuid
        );
        if (module) {
          const [item, value] = module;
          const textureShoeLowerBench =
            value?.textures?.get('shoe_lower_bench');

          supplierIds = {
            id: textureShoeLowerBench?.supplier?.id ?? supplierIds?.id,
            materialType:
              textureShoeLowerBench?.supplier?.materialType ??
              supplierIds?.materialType,
          };
          dispatch(setCurrentSupplier({ shoeLowerBench: supplierIds }));
          if (textureShoeLowerBench) {
            setTexture({
              material: textureShoeLowerBench.supplier?.name ?? '--',
              name: textureShoeLowerBench.textureCode ?? t('Not selected'),
              src: textureShoeLowerBench.textureUrl,
              textureId: textureShoeLowerBench.textureId,
            });
          } else {
            setTexture();
          }
          if (
            textureShoeLowerBench?.supplier?.group &&
            !groupMaterials.data[
              `${supplierId?.materialType}-${supplierId?.id}`
            ]?.includes(textureShoeLowerBench?.supplier?.group)
          ) {
            dispatch(
              fetchMaterialsByGroup({
                materialGroup: textureShoeLowerBench?.supplier?.group,
              })
            );
          }
        }
      }
      // const modules = sceneManager?.cabinetManager?.currentCabinet?.modules;
      // if (modules && selectedModel) {
      //   const supplierIds = { ...(supplierId ?? {}) };

      //   const moduleEntries = Array.from(modules.entries());
      //   const module = moduleEntries?.find(
      //     ([item, value]) => value.group.uuid === selectedModel?.uuid
      //   );

      //   let tempShoeLowerBench = null;
      //   moduleEntries.forEach(([item, value]) => {
      //     if (value?.textures.get('shoe_lower_bench')) {
      //       tempShoeLowerBench = value?.textures.get('shoe_lower_bench');
      //     }
      //   });

      //   if (module) {
      //     const [item, value] = module;

      //     const textileShoeLowerBench = value?.textures.get('shoe_lower_bench');
      //     supplierIds.textile = {
      //       id:
      //         textileShoeLowerBench?.supplier?.id ??
      //         tempShoeLowerBench?.supplier?.id ??
      //         supplierIds?.textile?.id,
      //       materialType:
      //         textileShoeLowerBench?.supplier?.materialType ??
      //         tempShoeLowerBench?.supplier?.materialType ??
      //         supplierIds?.textile?.materialType,
      //     };
      //     dispatch(setCurrentSupplier({ shoeLowerBench: supplierIds }));

      //     if (textileShoeLowerBench) {
      //       setTexture({
      //         material: textileShoeLowerBench.supplier?.name ?? '--',
      //         name: textileShoeLowerBench.textureCode ?? t('Not selected'),
      //         src: textileShoeLowerBench.textureUrl,
      //         textureId: textileShoeLowerBench.textureId,
      //       });
      //     } else {
      //       setTexture();
      //     }
      //   }
      // }
    },
    [selectedModel, supplierId, sceneManager]
  );

  // useEffect(() => {
  //   if (groupMaterials) {
  //     setActiveKeys(prev => [
  //       ...prev,
  //       ...groupMaterials.data[`${supplierId?.materialType}-${supplierId?.id}`]?.map(item => item.id)
  //     ]);
  //   }
  // }, [groupMaterials, supplierId?.id])

  const loadGroupMaterial = useCallback(
    ({ material_type: materialType }) => {
      try {
        const data = suppliers.data[materialType];
        let idSupplier = null;
        const modules = sceneManager?.cabinetManager?.currentCabinet?.modules;
        if (modules) {
          const moduleEntries = Array.from(modules.entries());
          const module = moduleEntries?.find(
            ([item, value]) => value.group.uuid === selectedModels[0].uuid
          );
          if (module) {
            const [item, value] = module;
            const textureShoeLowerBench =
              value?.textures?.get('shoe_lower_bench');

            idSupplier = textureShoeLowerBench?.supplier;

            const temp = {
              ...supplierId,
              ...{
                id: data?.[0]?.id,
                ...(idSupplier ?? {}),
                materialType: materialType,
              },
            };
            dispatch(setCurrentSupplier({ shoeLowerBench: temp }));
            if (temp?.id) {
              dispatch(
                fetchGroupMaterial({
                  // offset,
                  // limit,
                  productType: '',
                  materialType: materialType,
                  supplier: temp?.id,
                })
              );
            }
          }
        }
      } catch (error) {
        openMessageError({ content: t('Failed to load data!') });
      }
    },
    [supplierId?.textile, sceneManager, suppliers]
  );

  // useEffect(() => {
  //   if (sceneManager && open) {
  //     let material = {};
  //     const modules = sceneManager?.cabinetManager?.currentCabinet?.modules;
  //     if (modules) {
  //       const moduleEntries = Array.from(modules.entries());
  //       const module = moduleEntries?.find(
  //         ([item, value]) => value.group.uuid === selectedModels[0].uuid
  //       );
  //       if (module) {
  //         const [item, value] = module;
  //         const textureShoeLowerBench =
  //           value?.textures?.get('shoe-lower-bench');
  //         material = {
  //           ...material,
  //           textile: textureShoeLowerBench,
  //         };
  //         setCurrentMaterial({ ...material });
  //         if (textureShoeLowerBench?.texture?.supplier?.group) {
  //           setActiveKeys(prev => [
  //             ...prev,
  //             textureShoeLowerBench.texture.supplier.group,
  //           ]);
  //           dispatch(
  //             fetchMaterialsByGroup({
  //               materialGroup: textureShoeLowerBench.texture.supplier.group,
  //             })
  //           );
  //         }
  //       }
  //     }
  //   }
  // }, [open, sceneManager]);

  useEffect(() => {
    loadGroupMaterial({
      material_type: 'textile',
    });
  }, [suppliers]);

  useEffect(() => {
    if (supplierId?.id) {
      dispatch(
        fetchGroupMaterial({
          productType: '',
          materialType: 'textile',
          supplier: supplierId?.id,
        })
      );
    }
  }, [supplierId]);

  useEffect(() => {
    if (selectedModel) {
      traverseColorAndTexture(selectedModel);
    }
  }, [selectedModel]);

  useEffect(() => {
    if (!suppliers.data['textile']?.length) {
      dispatch(fetchSuppliers({ textureType: 'textile' }));
    }
  }, [suppliers.data['textile']]);

  return (
    <>
      {suppliers.data[supplierId?.materialType]?.find(
        item => supplierId && item.id === supplierId?.id
      ) ? (
        <div
          key={1}
          className="flex p-16 flex-col items-start gap-8 self-stretch bg-fills-white"
        >
          {[...(suppliers.data[supplierId?.materialType] ?? [])]
            ?.filter(item => supplierId && item.id === supplierId?.id)
            .map((item, index) => {
              return (
                <SelectionSupplier
                  key={index}
                  src={item.icon_url}
                  title={item.name}
                  description={''}
                  className={'self-stretch'}
                  onClick={() => setOpenSupplier(true)}
                />
              );
            })}
        </div>
      ) : null}

      <div
        className="flex flex-col p-8 items-start gap-16 grow self-stretch overflow-auto"
        style={{ backgroundColor: '#F7F7F7' }}
      >
        <div
          id="scrollableDiv"
          className="flex flex-col self-stretch grow overflow-scroll"
        >
          {groupMaterials.data[`${supplierId?.materialType}-${supplierId?.id}`]
            ?.length ? (
            <Collapse
              expandIcon={({ isActive, panelKey }) =>
                panelKey === listMaterials.isLoading ? (
                  <Spin spinning size="small" />
                ) : (
                  <span className="w-16 h-16 flex">
                    {isActive ? <Icon.ICExpandLess /> : <Icon.ICExpandMore />}
                  </span>
                )
              }
              activeKey={activeKeys}
              onChange={() => {}}
              className="self-stretch overflow-auto grow"
              rootClassName="self-stretch grow"
              items={
                [
                  ...(
                    groupMaterials.data[
                      `${supplierId?.materialType}-${supplierId?.id}`
                    ] ?? []
                  ).map(item => {
                    const groupId = item.id;
                    const isEmpty = !listMaterials.data[groupId]?.length;
                    const isLoading =
                      isEmpty && listMaterials.isLoading === groupId;
                    const formularPrice = item.description?.includes('giagoc')
                      ? item.description
                      : undefined;
                    return {
                      key: groupId,
                      onItemClick: e => {
                        if (!listMaterials.data[groupId]) {
                          setActiveKeys(prev => [...prev, e]);
                          dispatch(
                            fetchMaterialsByGroup({
                              materialGroup: e,
                            })
                          );
                        } else {
                          setActiveKeys(prev => {
                            if (prev.includes(e)) {
                              return prev.filter(key => key !== e);
                            } else {
                              return [...prev, e];
                            }
                          });
                        }
                      },
                      label: (
                        <span className="text-title-medium">
                          {getValueFromString(item.name)}
                        </span>
                      ),
                      classNames: {
                        body: 'self-stretch grow !p-0',
                        header: 'self-stretch grow',
                      },
                      isActive: !isLoading,
                      onKeyDown: e => {
                        e.stopPropagation();
                      },
                      children: (
                        <div
                          className="flex flex-row flex-wrap gap-2"
                          style={{ background: 'rgb(247, 247, 247)' }}
                        >
                          {isEmpty && !isLoading ? (
                            <div className="flex self-stretch items-center justify-center grow">
                              <Empty />
                            </div>
                          ) : (
                            <></>
                          )}
                          {listMaterials.data[groupId]?.map((item, index) => {
                            return (
                              <CardMaterial
                                key={index}
                                item={{
                                  src: item.thumbnail_url,
                                  title: item.name,
                                  description: item.code,
                                }}
                                active={
                                  texture && item.id === texture.textureId
                                }
                                onClick={async (func, applyToAll) => {
                                  if (item.thumbnail_url) {
                                    const textureController =
                                      sceneManager.textureController;
                                    const applyTexture = async ({
                                      module,
                                      texture = {
                                        textureId: item.id,
                                        textureCode: item.name,
                                        formularPrice,
                                        texturePrice: item.price,
                                        url: item.thumbnail_url,
                                        supplier: {
                                          ...(supplierId ?? {}),
                                          name: item.supplier_name,
                                          group: groupId,
                                        },
                                      },
                                      // excludeMeshTypes = [InsideType.DOOR, InsideType.DOOR_TEMPLATE],
                                    }) => {
                                      return await textureController.changeShoeLowerBench(
                                        {
                                          module,
                                          textureType: 'map',
                                          texture,
                                          // excludeMeshTypes,
                                        }
                                      );
                                    };

                                    const modules =
                                      sceneManager?.cabinetManager
                                        ?.currentCabinet?.modules;
                                    const moduleEntries = Array.from(
                                      modules.entries()
                                    );

                                    if (applyToAll && selectedModel) {
                                      const len = moduleEntries?.length;
                                      if (len) {
                                        for (let i = 0; i < len; i++) {
                                          const [key, value] = moduleEntries[i];
                                          const model = value.group;
                                          if (
                                            ['lower', 'upper', 'ceiling'].some(
                                              item =>
                                                model?.userData?.moduleType?.includes(
                                                  item
                                                ) &&
                                                selectedModel?.userData?.moduleType?.includes(
                                                  item
                                                )
                                            )
                                          )
                                            await applyTexture({
                                              module: value,
                                            });
                                        }
                                      }
                                    } else {
                                      const len = selectedModels.length;
                                      if (len) {
                                        for (let i = 0; i < len; i++) {
                                          const model = selectedModels[i];
                                          const [item, value] =
                                            moduleEntries?.find(
                                              ([item, value]) =>
                                                value.group.uuid === model.uuid
                                            );
                                          await applyTexture({ module: value });
                                        }
                                      }
                                    }
                                    traverseColorAndTexture(selectedModel);
                                    func();
                                  }
                                }}
                              />
                            );
                          })}
                        </div>
                      ),
                    };
                  }),
                ] //   formLayout.map((panel) => ({
                //   ...panel,
                //   extra: <ButtonIconGhostSmall icon={<Icon.ICSelectAll />} />,
                // }))
              }
            />
          ) : (
            <Empty />
          )}
        </div>
      </div>
    </>
  );
};
